import React, { useState } from 'react';
import Popup from '../../../components/popup/Popup';
import Loadable from '../../../components/loadable/Loadable';
import styles from './BoiQuiz.styles';
import Heading from '../../../components/heading/Heading';
import { HEADING } from '../../../components/heading/constants/constants';
import Icons from '../../../components/icons/Icons';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import VerticalSeparator from '../../../components/separator/verticalseparator/VerticalSeparator';
import { BUTTON_TYPE } from '../../../components/button/constants';
import Button from '../../../components/button/Button';
import Quiz from './quiz/Quiz';
import ImageIconPng from '../../../components/icons/vectors/ImageIconPng';

export default function BoiQuizContainer({isPopupOpen, onCloseCb=() => {},}){

    const [takeQuiz, setTakeQuiz] = useState(false);

    return <>
        <Popup onCloseCb={onCloseCb} customPopupHeaderStyles={styles.customPopupHeaderStyles} isPopupOpen={isPopupOpen} customPopupSyles={styles.popupStyles} overlayStyles={styles.popupoOverlay} childrenStyles={styles.popupChildrenStyles}>
            <Loadable currentState={{}} loadingStates={[]} isNewLoadable={true}>
                <div style={styles.mainContainer}>
                    {
                        !takeQuiz ? <div>
                            <div style={styles.fincenLogoContainer}>
                                <ImageIconPng
                                    src={'https://prod-cdn.tax1099.com/Content/themes/SkyBlue/Images/images_v3/logo-fin.jpg'}
                                    alt=""
                                    style={styles.fincenLogo}
                                />
                                <Heading type={HEADING.H2}>FinCEN BOI</Heading>
                            </div>
                            <div style={styles.titleIconDiv}>
                                <Icons familyName={'vec'} iconName={VEC_ICON_NAME.PAPER_SCROLL_ICON} />
                                <Heading type={HEADING.H2}>Leading the way in innovation, Tax1099 proudly offers cutting-edge BOI reporting services.</Heading>
                            </div>
                            <div style={styles.fancyRowFirst}>
                                <div style={styles.leftColumn}>
                                    <Heading type={HEADING.H1} customStyle={styles.fancyRowTitle} >
                                        What is FinCEN Beneficial Ownership Information?
                                    </Heading>
                                    <div style={styles.paragraphText}>
                                        BOI refers to Beneficial ownership information. Effective January 1, 2024, companies, including corporations, limited liability companies (LLC), as well as some partnerships and trusts are required to provide FinCEN with data regarding the individuals who ultimately hold or manage them. 
                                    </div>
                                </div>
                                <Icons familyName={'vec'} style={styles.rightIcon} iconName={VEC_ICON_NAME.BOI_BOY_W_QUESTION_ICON} />
                            </div>

                            <div style={styles.fancyRowSecond}>
                                <Icons familyName={'vec'} style={styles.leftIcon} iconName={VEC_ICON_NAME.BOI_GIRL_ICON} />
                                <div style={styles.rightColumn}>
                                    <Heading type={HEADING.H1} customStyle={styles.fancyRowTitle} >
                                        Who is required to file?
                                    </Heading>
                                    <div style={styles.paragraphText}>
                                        A "reporting company" is broadly defined as any corporation, limited liability company (LLC), or similar entity that is created or registered to conduct business in the United States by filing formation documents with a state secretary's office or a comparable authority. It's important to note that certain types of entities are exempt from the reporting requirements outlined in the CTA 
                                    </div>
                                </div>
                            </div>
                            <div style={styles.rowWVerticalSeparator}>
                                <VerticalSeparator style={styles.verticalSeparatorStyles} />
                                <Heading customStyle={styles.takeQuizTextStyles} >Take a short quiz to determine if your company is a “Reporting Company” under the Corporate Transparency Act. </Heading>
                            </div>
                            <div style={styles.buttonRows}>
                                <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={styles.buttonStyle} onClickCb={onCloseCb}>Skip</Button>
                                <Button type={BUTTON_TYPE.PRIMARY} style={styles.buttonStyle} onClickCb={() => setTakeQuiz(true)}>Take the quiz</Button>
                            </div>
                        </div>
                        :
                        <div>
                            <div style={styles.rowWVerticalSeparator}>
                                <VerticalSeparator style={styles.verticalSeparatorStyles} />
                                <Heading customStyle={styles.takeQuizTextStyles} >Take a short quiz to determine if your company is a “Reporting Company” under the Corporate Transparency Act. </Heading>
                            </div>
                            <div style={styles.whiteCardContainer}>
                                <Quiz />
                            </div>
                            
                        </div>
                    }
                    
                </div>
            </Loadable>
        </Popup >
    </>
}